"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BlurImage;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _useImageLoader3 = _interopRequireDefault(require("./useImageLoader"));

var styles = {
  blur: {
    filter: 'blur(15px)',
    transition: 'all 1s'
  },
  noBlur: {
    transition: 'all 3s'
  }
};

function BlurImage(props) {
  var alt = props.alt,
      src = props.src,
      placeholder = props.placeholder,
      rest = (0, _objectWithoutProperties2["default"])(props, ["alt", "src", "placeholder"]);

  var _useImageLoader = (0, _useImageLoader3["default"])({
    src: src,
    placeholder: placeholder
  }),
      _useImageLoader2 = (0, _slicedToArray2["default"])(_useImageLoader, 2),
      image = _useImageLoader2[0],
      loading = _useImageLoader2[1];

  return _react["default"].createElement("img", (0, _extends2["default"])({
    alt: alt,
    src: image,
    style: loading ? styles.blur : styles.noBlur
  }, rest));
}